import { NavigateOptions, useNavigate } from 'react-router-dom'

import { useAppPath } from './useAppPath'

export const useAppNavigate = () => {
  const navigate = useNavigate()
  const path = useAppPath()

  return (url = '', options?: NavigateOptions) => {
    if (!path) return

    navigate(`${path}${url}`, options)
  }
}
